export const getBillingHistoriesUrl = () => '/business/billing_histories';

export const getBillingHistoryUrl = () => '/business/billing';

export const getCardDetailsUrl = () => '/business/payment_methods';

export const getCardDetailUrl = (id: string) => `/business/payment_methods/${id}`;

export const getBusinessPlanUrl = (id: number) => `/business/business_plans/${id}`;

export const getCouponUrl = () => '/business/apply_coupon';

export const getPayDuesUrl = () => '/business/pay_now';

export const getMarkBillingStatusPaidUrl = (id: number) => `/business/billing_histories/${id}/mark_paid`;

export const getMarkBillingStatusVoidUrl = (id: number) => `/business/billing_histories/${id}/mark_void`;

export const getFetchBusinessInvoiceUrl = (id: number) => `/business/billing_histories/${id}/fetch_invoice`;

export const getBusinessInvoiceTransactionsUrl = () => '/business/billing/invoice_transactions';

export const getCancelBusinessSubscriptionUrl = () => '/business/billing/cancel_subscription';
